<template>
    <div>
      <div @click="openModal()">
        <slot name="buttonTop" />
      </div>
      <ModalHeadlessUI ref="modal">
        <template #default>
          <h1 class="font-bold mb-4 text-3xl text-center">
            Edit Automation
          </h1>
          <form id="automationForm" name="automationForm" @submit.prevent="updateAutomation">
            <div>
              <div class="flex justify-between">
                <div>
                  <select-input v-model="automationForm.delay_minutes" :error="automationForm.errors.delay_minutes" class="pr-6 pb-4 w-full" label="Minutes">
                    <option v-for="n in getNumbers(0,59,1)" :key="n" :value="n">{{ n }} Mins</option>
                  </select-input>
                </div>
                <div>
                  <select-input v-model="automationForm.delay_hours" :error="automationForm.errors.delay_hours" class="pr-6 pb-4 w-full" label="Hours">
                    <option v-for="n in getNumbers(0,24,1)" :key="n" :value="n">{{ n }} Hours</option>
                  </select-input>
                </div>
                <div>
                  <select-input v-model="automationForm.delay_days" :error="automationForm.errors.delay_days" class="pr-6 pb-4 w-full" label="Days">
                    <option v-for="n in getNumbers(0,24,1)" :key="n" :value="n">{{ n }} Days</option>
                  </select-input>
                </div>
                <div>
                  <select-input v-model="automationForm.delay_months" :error="automationForm.errors.delay_months" class="pr-6 pb-4 w-full" label="Months">
                    <option v-for="n in getNumbers(0,12,1)" :key="n" :value="n">{{ n }} Months</option>
                  </select-input>
                </div>
              </div>
            </div>
            <select-input v-model="automationForm.type" :error="automationForm.errors.type" class="pr-6 pb-4 w-full" label="Automation Type">
              <option value="reminder">Reminder</option>
              <option value="email">Email</option>
              <option value="text">SMS</option>
              <option value="voicemail">Voicemail</option>
              <option value="tag">Tag</option>
              <option value="status">Status</option>
            </select-input>
            <text-input v-if="!hideEmail" v-model="automationForm.subject" :error="automationForm.errors.subject" class="pr-6 pb-4 w-full" label="Email Subject" />
            <div v-if="hideForVoicemail && hideForTag && hideForStatus">
              <label class="form-label">Message:</label>
              <TaskEditor v-model="automationForm.message" :error="automationForm.errors.message" />
            </div>
            <text-input v-if="!hideForTag" v-model="automationForm.message" :error="automationForm.errors.message" class="pr-6 pb-4 w-full" label="Enter Tag" />
            <select-input v-if="!hideForVoicemail" v-model="automationForm.message" :error="automationForm.errors.type" class="pr-6 pb-4 w-full" label="Voicemail Message">
              <option v-for="voicemail in voicemails" :key="voicemail.id" :value="voicemail.name">{{ voicemail.display }}</option>
            </select-input>
            <StatusDropdown
                v-if="!hideForStatus" 
                class="pr-6 pb-4 w-full"
                v-model="automationForm.message"
                label="Lead Status"
                :error="automationForm.errors.message"
                @change="handleStatusChange"
                @statusText="handleStatusText"
              />
            <div v-if="automationForm.errors.message" class="form-error">{{ automationForm.errors.message }}</div>
            <div v-if="hideForVoicemail && hideForTag && hideForStatus" class="pb-4 w-full">
              <attachment-uploader :initial-attachment-url="automationForm.attachment" message-type="email" @update:attachmentUrl="updateAttachmentUrl" @update:attachmentName="updateAttachmentName"/>
            </div>
            <div class="tag-input w-full mb-5 min-w-full flex-row">
              <div v-if="hideForVoicemail && hideForTag && hideForStatus">
                <div class="flex text-left mt-2 text-m w-full flex-wrap">
                <span class="cursor-pointer tag-input__tag text-sm">Lead Fields</span>
                <span class="cursor-pointer tag-input__tag bg-indigo-600 text-white text-sm" @click="insertField('%first%')">first</span>
                <span class="cursor-pointer tag-input__tag bg-indigo-600 text-white text-sm" @click="insertField('%fullName%')">full</span>
                <span class="cursor-pointer tag-input__tag bg-indigo-600 text-white text-sm" @click="insertField('%phone%')">phone</span>
                <span class="cursor-pointer tag-input__tag bg-indigo-600 text-white text-sm" @click="insertField('%email%')">email</span>
                <span class="cursor-pointer tag-input__tag bg-indigo-600 text-white text-sm" @click="insertField('%fullNameCoborrower%')">coname</span>
                <span class="cursor-pointer tag-input__tag bg-indigo-600 text-white text-sm" @click="insertField('%phoneCoborrower%')">cophone</span>
                <span class="cursor-pointer tag-input__tag bg-indigo-600 text-white text-sm" @click="insertField('%emailCoborrower%')">coemail</span>
              </div>
              <div class="flex tag-input text-left mt-2 pb-2 text-m w-fullmin-w-full">
                <span class="cursor-pointer tag-input__tag text-sm">User Fields</span>
                <span class="cursor-pointer tag-input__tag bg-indigo-600 text-white text-sm" @click="insertField('%user_first_name%')">first</span>
                <span class="cursor-pointer tag-input__tag bg-indigo-600 text-white text-sm" @click="insertField('%user_last_name%')">last</span>
                <span class="cursor-pointer tag-input__tag bg-indigo-600 text-white text-sm" @click="insertField('%user_phone%')">phone</span>
                <span class="cursor-pointer tag-input__tag bg-indigo-600 text-white text-sm" @click="insertField('%user_email%')">email</span>
                <span class="cursor-pointer tag-input__tag bg-indigo-600 text-white text-sm" @click="insertField('%user_application_link%')">app link</span>
                <span class="cursor-pointer tag-input__tag bg-indigo-600 text-white text-sm" @click="insertField('%user_appointment_link%')">appointment</span>
              </div>
              </div>
              <div class="flex justify-center items-center mt-5">
                <div>
                  <loading-button :loading="automationForm.processing" class="btn-indigo ml-auto" type="submit">Update Automation</loading-button>
                </div>
              </div>
            </div>
            <div class="py-10" />
          </form>
        </template>
      </ModalHeadlessUI>
    </div>
  </template>

  <script>
  import ModalHeadlessUI from '@/Shared/ModalHeadlessUI'
  import TaskEditor from '@/Shared/TaskEditor'
  import SelectInput from '@/Shared/SelectInput'
  import TextInput from '@/Shared/TextInput'
  import LoadingButton from '@/Shared/LoadingButton'
  import AttachmentUploader from '@/Shared/AttachmentUploader'
  import StatusDropdown from '@/Shared/StatusDropdown'
  import { router } from '@inertiajs/vue3'

  export default {
    components: {
      ModalHeadlessUI,
      TaskEditor,
      SelectInput,
      TextInput,
      LoadingButton,
      AttachmentUploader,
      StatusDropdown,
    },
    props: {
      automation:{
        type: Object,
        default: null,
      },
    },

    data() {
      return {
        automationForm: router.form({
          campaign_id: this.automation.campaign_id,
          delay_minutes: this.automation.delay_minutes,
          delay_hours: this.automation.delay_hours,
          delay_days: this.automation.delay_days,
          delay_months: this.automation.delay_months,
          type: this.automation.type,
          subject: this.automation.subject,
          message: this.automation.message,
          attachment: this.automation.attachment,
          attachmentName: this.automation.attachmentName,
          delay_from: this.automation.delay_from,
        }),
        attachmentError: '',
        hideSubject: true,
        voicemails: [
          { id: 1, name: 'abird-intro', display: 'Anthony Intro' },
          { id: 2, name: 'damon-intro', display: 'Damon Intro' },
          { id: 2, name: 'eric-intro', display: 'Eric Intro' },
          { id: 2, name: 'heather-intro', display: 'Heather Intro' },
          { id: 2, name: 'jenna-intro', display: 'Jenna Intro' },
          { id: 2, name: 'john-intro', display: 'John Intro' },
          { id: 2, name: 'jwoodwyk-intro', display: 'Josh Intro' },
          { id: 2, name: 'tomas-intro', display: 'Tomas Intro' },
        ],
      }
    },
    computed:{
      hideEmail() {
        return this.automationForm.type == 'email' ?  false : true
      },
      hideForVoicemail() {
        return this.automationForm.type == 'voicemail' ?  false : true
      },
      hideForTag() {
        return this.automationForm.type == 'tag' ?  false : true
      },
      hideForStatus() {
        return this.automationForm.type == 'status' ?  false : true
      },
    },
    methods:{
      insertField(field) {
        this.automationForm.message = this.automationForm.message + field
      },
      getNumbers:function(start,stop,step = 1){
        return new Array((stop - start) / step + 1).fill(start).map((n, i) => start + i * step);
      },
      openModal() {
        this.$refs.modal.openModal()
      },
      closeModal() {
        this.$refs.modal.closeModal()
      },
      onTypeChange: function(event){
        var type = event.target.value
        type == 'email' ? this.hideSubject = false : this.hideSubject = true
      },
      handleStatusChange(newValue) {
        this.automationForm.message = newValue
      },
      handleStatusText(newValue) {
        this.automationForm.subject = newValue
      },
      updateMessage: function(messageValue){
        this.automationForm.message=messageValue
      },
      isImage(url) {
        // Regular expression to match common image extensions
        const imageExtensions = /\.(jpg|jpeg|png|gif)$/i;
        return imageExtensions.test(url);
      },
      removeAttachment() {
        this.automationForm.attachment=null
        this.automationForm.attachmentName=null
      },
      updateAttachmentUrl(url) {
        this.automationForm.attachment = url
      },
      updateAttachmentName(name) {
        this.automationForm.attachmentName = name
      },
      updateAutomation() {
        if (this.automationForm.type === 'voicemail') {
          // Check if the selected voicemail is in the list
          const voicemailNames = this.voicemails.map(voicemail => voicemail.name);
          if (!voicemailNames.includes(this.automationForm.message)) {
            // Handle invalid voicemail selection
            alert('Invalid voicemail selection');
            return;
          }
        }
        var postTo = '/automations/'+this.automation.id
        router.put(postTo, this.automationForm, {
          onSuccess: () => {
            this.closeModal()
          },
          only: ['campaign'],
          preserveScroll: true,
        })
      },
    },
  }
  </script>
